<template>
  <ion-select
    :model-value="modelValue"
    @ionChange="handleChange"
    :disabled="disabled"
    label="Unité :"
    placeholder="Select"
  >
    <ion-select-option
      v-for="unity in unities"
      :key="unity.short_name"
      :value="unity.short_name"
    >
      {{ unity.label }} {{unity.short_name ? '(' + unity.short_name + ')' : '' }}
    </ion-select-option>
  </ion-select>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IonSelect, IonSelectOption } from '@ionic/vue';
import axios from 'axios';

type Unity = {
  short_name: string;
  label?: string;
};

export default defineComponent({
  name: 'UnitySelector',
  components: {
    IonSelect,
    IonSelectOption,
  },
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['ionChange', 'update:modelValue'],
  data() {
    return {
      unities: [] as Unity[],
    };
  },
  async mounted() {
    await this.fetchUnities();
  },
  methods: {
    async fetchUnities() {
      try {
        const response = await axios.get('/unities');
        this.unities = response.data;
      } catch (error) {
        console.error('Error fetching unities:', error);
      }
    },
    handleChange(event: CustomEvent) {
      this.$emit('ionChange', event);
      this.$emit('update:modelValue', event.detail.value);
    },
  },
});
</script>
